import { styled } from "@material-ui/core/styles";

const Wrapper = styled("div")({
  padding: 20,
});

export default Wrapper;
